import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-gray-50 to-white">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/bb975ccc6d84d177aa3ef0973a0ada87.jpg')`
        }}
      ></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
            Where Talent Meets{' '}
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Technology
            </span>{' '}
            - Deploy A.I. Agents that Scale Your Business
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed max-w-3xl mx-auto">
            Bridge the gap between human expertise and intelligent automation. Our A.I. agents amplify your team's capabilities while delivering exceptional results 24/7.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button size="lg" href="/contact">
              Deploy Your First A.I. Agent
            </Button>
            <Button variant="outline" size="lg" href="/case-studies">
              View Case Studies
            </Button>
          </div>
          
          <div className="mt-12 flex items-center justify-center space-x-8 text-sm text-gray-500">
            <div className="flex items-center space-x-2">
              <i className="ri-check-line text-green-500"></i>
              <span>24/7 Automation</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-check-line text-green-500"></i>
              <span>No Setup Fees</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-check-line text-green-500"></i>
              <span>ROI Guaranteed</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
